import { ConfigurationItem } from "constants/configurations";
import { useState } from "react";

type UseTabTransitionProps = {
  onSelectedTabChange: (id: ConfigurationItem) => void;
};

export function useTabTransition({
  onSelectedTabChange,
}: UseTabTransitionProps) {
  const [tabTransition, setTabTransition] = useState<{
    isTabChangeRequested: boolean;
    shouldInterceptOnChangeTab: boolean;
    targetTabChange: ConfigurationItem | null;
  }>({
    isTabChangeRequested: false,
    shouldInterceptOnChangeTab: false,
    targetTabChange: null,
  });

  const handleChangeTab = (target: ConfigurationItem) => {
    onSelectedTabChange(target);
    setTabTransition({
      isTabChangeRequested: false,
      shouldInterceptOnChangeTab: false,
      targetTabChange: null,
    });
  };

  const handleRequestChangeTab = (target: ConfigurationItem) => {
    if (tabTransition.shouldInterceptOnChangeTab) {
      setTabTransition((prevState) => ({
        ...prevState,
        isTabChangeRequested: true,
        targetTabChange: target,
      }));
      return;
    }

    handleChangeTab(target);
  };

  const handleToggleIntercept = (intercept: boolean) => {
    setTabTransition((prevState) => ({
      ...prevState,
      shouldInterceptOnChangeTab: intercept,
    }));
  };

  const handleCancelChangeTab = () => {
    setTabTransition((prev) => ({
      ...prev,
      isTabChangeRequested: false,
      targetTabChange: null,
    }));
  };

  const handleConfirmChangeTab = () => {
    if (!tabTransition.targetTabChange) return;
    handleChangeTab(tabTransition.targetTabChange);
  };

  return {
    handleCancelChangeTab,
    handleConfirmChangeTab,
    handleRequestChangeTab,
    handleToggleIntercept,
    tabTransition,
  };
}
